import API_CONFIG from "../../config/api";

const base = API_CONFIG.BASE_URL;
const headers = (companyId = null) => ({
  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  ...(companyId ? { "X-Company-Id": String(companyId) } : {}),
});

const parse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || data.error || `Erreur ${response.status}`);
  return data;
};

const queryString = (params) => new URLSearchParams(
  Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)
).toString();

const scopedParams = (params, scope) => ({
  ...params,
  ...(scope === "all" ? { scope: "all" } : {}),
});

export async function getAuditDashboard(period = 7, companyId, options = {}) {
  const response = await parse(await fetch(
    `${base}/api/audit/dashboard?${queryString(scopedParams({ period }, options.scope))}`,
    { headers: headers(companyId), signal: options.signal }
  ));
  return response.data || {};
}

export async function listAuditLogs(params, companyId, options = {}) {
  return parse(await fetch(`${base}/api/audit/logs?${queryString(params)}`, {
    headers: headers(companyId),
    signal: options.signal,
  }));
}

export async function listAuditConnections(params, companyId, options = {}) {
  return parse(await fetch(
    `${base}/api/audit/auth/history?${queryString(scopedParams(params, options.scope))}`,
    { headers: headers(companyId), signal: options.signal }
  ));
}

export async function listAuditSessions(windowMinutes = 15, companyId, options = {}) {
  return parse(await fetch(
    `${base}/api/audit/auth/active?${queryString(scopedParams({ windowMinutes }, options.scope))}`,
    { headers: headers(companyId), signal: options.signal }
  ));
}

export const parseAuditDetails = (value) => {
  if (!value) return {};
  if (typeof value === "object") return value;
  try { return JSON.parse(value); } catch { return { description: String(value) }; }
};

export const auditDate = (value, seconds = false) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", ...(seconds ? { second: "2-digit" } : {}) });
};

export const MODULE_LABELS = {
  produits: "Produits", ventes: "Ventes", achats: "Achats", rh: "Ressources humaines",
  depenses_commercial: "Dépenses · Commercial", depenses_logistics: "Dépenses · Logistique",
  depenses_hotellerie: "Dépenses · Hôtellerie", logistics: "Logistique", users: "Utilisateurs",
  utilisateurs: "Utilisateurs", companies: "Entreprises", entreprises: "Entreprises",
  ecommerce: "E-commerce", warehouse: "Établissements", stock: "Stock", payments: "Paiements",
  paiements: "Paiements", reports: "Rapports", settings: "Paramètres", auth: "Authentification",
};

export const moduleLabel = (value) => MODULE_LABELS[value] || value || "Système";
export const statusMeta = (status) => ({
  success: ["Succès", "ok"], failure: ["Échec", "danger"], partial: ["Partiel", "warn"],
}[status] || [status || "Inconnu", "off"]);
